/**
 * 我的订单
 * created by 蔺晨 on 2020/03/11.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Flex, SearchBar } from 'antd-mobile';
import NavBar from 'widget/NavBar';
import BankSearchMod from './indexMod';
import './index.less';

import Config from 'config/Config';

@observer
class BankSearchView extends Component {
  constructor(props, context) {
    super(props, context);

    this.stores = new BankSearchMod();
    this.searchRef = null;
    this.state = {
      show: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const { address, headBankId } = nextProps;
    if ((address || []).length < 2) return;
    const [{ value: preProvinceCode }, { value: preCityCode }] = this.stores.address || [{}, {}];
    const [{ value: nextProvinceCode }, { value: nextCityCode }] = address || [{}, {}];
    // 如果上一次的props参数和本次一样，则不进行请求支行
    if (
      preProvinceCode == nextProvinceCode &&
      preCityCode == nextCityCode &&
      `${headBankId}` === `${this.stores.headBankId}`
    )
      return;
    this.stores.changeState({ address, headBankId, branchBankList: [] });
    this.stores.getBranchBankList();
  }

  popup = () => {
    this.stores.changeState({ keyword: '' });
    this.setState({ show: true }, () => {
      this.searchRef.focus();
    });
  };

  /**
   * 顶部导航栏
   */
  renderNavBar = () => {
    const { keyword } = this.stores;
    return (
      <NavBar
        leftContent={
          this.props.customLeft ? (
            <span className="iconfont icon-fanhui" style={{ color: '#000000CC' }} />
          ) : null
        }
        onLeftClick={() => this.setState({ show: false })}>
        <SearchBar
          placeholder="请输入支行名称"
          maxLength={100}
          value={keyword}
          onChange={(keyword) => this.stores.changeState({ keyword })}
          className="search-bar"
          ref={(ref) => {
            this.searchRef = ref;
          }}
        />
      </NavBar>
    );
  };

  /* 
  支行列表数据
   */
  listData = () => {
    const { onChange } = this.props;
    const { bankList } = this.stores;

    return (
      <div className="common-box bottom-box">
        {!bankList.length ? (
          <Flex className="list-item">无支行信息</Flex>
        ) : (
          bankList.map((item, index) => {
            return (
              <Flex
                key={`bank_${index}`}
                className="list-item"
                onClick={() => {
                  onChange && onChange({ name: item.name, code: item.code });
                  this.setState({ show: false });
                }}>
                {item.name}
              </Flex>
            );
          })
        )}
      </div>
    );
  };

  render() {
    const { show } = this.state;
    return (
      <div className={show ? 'bank-search' : 'bank-search hide'}>
        {this.renderNavBar()}
        {this.listData()}
      </div>
    );
  }
}

export default BankSearchView;



// WEBPACK FOOTER //
// ./src/pubBiz/BankSearch/index.js